export const validation = {
	maxValue: "Value exceeds the maximum allowed",

	// Sale type validation
	saleType: {
		required: "Sale type is required",
		invalid: "Invalid sale type",
	},
	unitOfMeasure: {
		required: "Unit of measure is required",
		requiredForVariable: "Unit of measure is required for variable price",
		invalid: "Invalid unit of measure",
	},
	price: {
		required: "Price is required",
		invalid: "Price is required",
		min: "Price must be greater than or equal to 0",
	},
	quantity: {
		required: "Quantity is required",
		invalid: "Invalid quantity",
		min: "Quantity must be greater than 0",
		max: "Quantity must be less than 10,000",
	},

	// Fiscal data validation
	ncm: {
		required: "NCM is required",
		invalid: "NCM must contain between 4 and 8 digits",
	},
	cest: {
		required: "CEST is required",
		invalid: "CEST must contain exactly 7 digits",
	},
	fiscalProfile: {
		required: "Fiscal profile is required",
		invalid: "Invalid fiscal profile",
		min: "Fiscal profile is required",
	},
	fiscalGroup: {
		required: "Fiscal group is required",
		invalid: "Invalid fiscal group",
		min: "Fiscal group is required",
	},
	fiscalIcmsBaseCalculoRetSt: {
		required: "Field is required",
		min: "Value must be greater than zero",
	},
	fiscalIcmsValorSubstituto: {
		required: "Field is required",
	},
	fiscalIcmsAliquotaFinal: {
		required: "Field is required",
		min: "Value must be greater than zero",
	},

	// General fields
	name: {
		required: "Name is required",
		min: "Name is required",
		max: "Name must not exceed 100 characters",
	},
	systemProduct: {
		required: "System product is required",
	},
	productType: {
		required: "Product type is required",
		invalid: "Invalid product type",
		min: "Product type is required",
	},
	category: {
		required: "Category is required",
		min: "Category is required",
	},
	sku: {
		invalid: "SKU must contain only letters, numbers, hyphens and underscores",
	},
	preparationTime: {
		int: "Preparation time must be an integer",
		min: "Preparation time must be greater than 0",
		max: "Preparation time must be less than 1440 minutes (24 hours)",
	},
	description: {
		max: "Description must not exceed 500 characters",
	},
	releasePrice: {
		min: "Release price must be greater than or equal to 0",
		required: "Release price is required",
		maxPrice: "Release price cannot be greater than the product price",
	},

	// Stock validation
	isStockable: {
		required: "Required field",
		invalid: "Invalid value",
	},
	stockControlledBy: {
		required: "Stock controlled by is required when product is stockable",
		invalid: "Invalid stock unit",
	},
	conversionQuantity: {
		required: "Conversion quantity is required",
		min: "Quantity must be greater than 0",
		max: "Conversion quantity must be less than 10,000",
	},
	conversionUnit: {
		required: "Conversion unit is required",
		invalid: "Invalid conversion unit",
	},

	// Image validation
	image: {
		required: "Image is required",
		invalid: "Invalid image",
	},

	// Mountable product validation
	mountable: {
		title: {
			required: "Step title is required",
			min: "Step title is required",
		},
		pricing: {
			required: "Pricing method is required",
			invalid: "Invalid pricing method",
		},
		min: {
			required: "Minimum value is required",
			minValue: "Minimum value must be greater than or equal to 0",
		},
		max: {
			required: "Maximum value is required",
			minValue: "Maximum value must be greater than 0",
			minGreaterThanMin: "Maximum value must be greater than or equal to the minimum",
		},
		items: {
			min: "There must be at least one item in the step",
		},
		item: {
			productId: {
				required: "Item is required",
				min: "Item is required",
				duplicate: "This item has already been added to this step",
			},
			price: {
				min: "Price must be greater than or equal to 0",
			},
			storageCount: {
				required: "Deducted quantity is required",
				minValue: "Deducted quantity must be greater than 0",
			},
		},
	},
};
